type FinishCreatedProfileArgs = {
  isKiosk: boolean;
  completeKiosk(): void;
  navigateDashboard(): void;
};

export const finishCreatedProfile = ({
  isKiosk,
  completeKiosk,
  navigateDashboard,
}: FinishCreatedProfileArgs) => {
  if (isKiosk) {
    completeKiosk();
    return;
  }

  navigateDashboard();
};
